import { 
  GET_USER_TYPE,
  GET_USER_TYPE_SUCCESS,
  GET_USER_TYPE_ERROR,

  GET_USER_TYPE_LIST,
  GET_USER_TYPE_LIST_SUCCESS,
  GET_USER_TYPE_LIST_ERROR,
  
  CREATE_USER_TYPE,
  CREATE_USER_TYPE_SUCCESS,
  CREATE_USER_TYPE_ERROR, 

  UPDATE_USER_TYPE,
  UPDATE_USER_TYPE_SUCCESS,
  UPDATE_USER_TYPE_ERROR,

  DELETE_USER_TYPE,
  DELETE_USER_TYPE_SUCCESS,
  DELETE_USER_TYPE_ERROR,
} from "./actionTypes"
  
  const initialState = {
    GET_USER_TYPE_SUCCESS: "",
    GET_USER_TYPE_ERROR: "",
    GET_USER_TYPE_LIST_SUCCESS: "",
    GET_USER_TYPE_LIST_ERROR: "",
    CREATE_USER_TYPE_SUCCESS: "",
    CREATE_USER_TYPE_ERROR: "",
    UPDATE_USER_TYPE: "",
    UPDATE_USER_TYPE_SUCCESS: "",
    UPDATE_USER_TYPE_ERROR: "",
    DELETE_USER_TYPE: "",
    DELETE_USER_TYPE_SUCCESS: "",
    DELETE_USER_TYPE_ERROR: "",
    loading: false,
  }
  
  const reducer = (state = initialState, action: any) => {
    switch (action.type) {
      // ---------------------------------------------GET_USER_TYPE
      case GET_USER_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_USER_TYPE_SUCCESS:
        state = {
          ...state,
          GET_USER_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_USER_TYPE_ERROR:
        state = { 
          ...state, 
          GET_USER_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------GET_USER_TYPE_LIST
      case GET_USER_TYPE_LIST:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_USER_TYPE_LIST_SUCCESS:
        state = {
          ...state,
          GET_USER_TYPE_LIST_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_USER_TYPE_LIST_ERROR:
        state = { 
          ...state, 
          GET_USER_TYPE_LIST_ERROR: action.payload, 
          loading: false 
        }
        break
        
      // ---------------------------------------------CREATE_USER_TYPE
      case CREATE_USER_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case CREATE_USER_TYPE_SUCCESS:
        state = {
          ...state,
          CREATE_USER_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case CREATE_USER_TYPE_ERROR:
        state = { 
          ...state, 
          CREATE_USER_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------UPDATE_USER_TYPE
      case UPDATE_USER_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case UPDATE_USER_TYPE_SUCCESS:
        state = {
          ...state,
          UPDATE_USER_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case UPDATE_USER_TYPE_ERROR:
        state = { 
          ...state, 
          UPDATE_USER_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DELETE_USER_TYPE
      case DELETE_USER_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case DELETE_USER_TYPE_SUCCESS:
        state = {
          ...state,
          DELETE_USER_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case DELETE_USER_TYPE_ERROR:
        state = { 
          ...state, 
          DELETE_USER_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DEFAULT
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reducer
  